import React, { Component } from 'react';
import './Video.css';
import EditBar from '../EditBar/EditBar';

class Video extends Component {
  toggleEditing(toggle) {
    if (this.props.onToggleEditing) {
      this.props.onToggleEditing(toggle);
    }
  }

  render() {
    const {
      sectionIndex,
      contentBlockIndex,
      removeContentBlock,
      videoUrl,
      autoplay,
      fullscreen,
      title,
      titleFontSize,
      description
    } = this.props;

    return (
      <div className={`video edit-wrapper`}>
        {title && (
          <div className={`text-title ${titleFontSize ? titleFontSize : ''}`}>
            {title}
          </div>
        )}
        {description && <p>{description}</p>}
        <div className="player">
          <iframe
            type="text/html"
            src={`${videoUrl}${autoplay ? '?autoplay=1' : ''}`}
            allowFullScreen={fullscreen ? true : false}
            frameBorder="0"
            title={title || 'Video'}
          />
        </div>
        <EditBar
          toggleEditing={() => this.toggleEditing(true)}
          removeContentBlock={() =>
            removeContentBlock(sectionIndex, contentBlockIndex)
          }
        />
      </div>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/landingPage/Video/Video.js